import { apiClient } from './ApiClient'
import { ApiResponse } from '../types/entities'

export interface TeamsIntegration {
  enabled: boolean;
  webhookUrl?: string;
  isConfigured: boolean;
}

export interface SaveTeamsIntegrationRequest {
  enabled: boolean;
  webhookUrl?: string;
}

export interface TestWebhookRequest {
  webhookUrl: string;
}

export interface TestWebhookResponse {
  success: boolean;
  message: string;
}

export interface ZapierEvent {
  key: string;
  name: string;
  description: string;
}

export interface ZapierIntegration {
  enabled: boolean;
  webhookUrl?: string;
  events: string[];
  lastTriggered?: string;
  isConfigured: boolean;
}

export interface SaveZapierIntegrationRequest {
  enabled: boolean;
  webhookUrl?: string;
  events?: string[];
}

export class IntegrationsService {
  private static readonly BASE_PATH = '/integrations'

  static async getTeamsIntegration(): Promise<TeamsIntegration> {
    const response = await apiClient.getWithResponse<TeamsIntegration>(`${this.BASE_PATH}/teams`)
    return response.data
  }

  static async saveTeamsIntegration(request: SaveTeamsIntegrationRequest): Promise<TeamsIntegration> {
    const response = await apiClient.post<ApiResponse<TeamsIntegration>>(`${this.BASE_PATH}/teams`, request)
    return response.data
  }

  static async testTeamsWebhook(request: TestWebhookRequest): Promise<TestWebhookResponse> {
    const response = await apiClient.post<ApiResponse<TestWebhookResponse>>(`${this.BASE_PATH}/teams/test`, request)
    return response.data
  }

  static async disconnectTeamsIntegration(): Promise<void> {
    await apiClient.delete(`${this.BASE_PATH}/teams`)
  }

  // Zapier Integration
  static async getZapierIntegration(): Promise<ZapierIntegration> {
    const response = await apiClient.getWithResponse<ZapierIntegration>(`${this.BASE_PATH}/zapier`)
    return response.data
  }

  static async getZapierEvents(): Promise<ZapierEvent[]> {
    const response = await apiClient.getWithResponse<{ events: ZapierEvent[] }>(`${this.BASE_PATH}/zapier/events`)
    return response.data.events
  }

  static async saveZapierIntegration(request: SaveZapierIntegrationRequest): Promise<ZapierIntegration> {
    const response = await apiClient.post<ApiResponse<ZapierIntegration>>(`${this.BASE_PATH}/zapier`, request)
    return response.data
  }

  static async testZapierWebhook(request: TestWebhookRequest): Promise<TestWebhookResponse> {
    const response = await apiClient.post<ApiResponse<TestWebhookResponse>>(`${this.BASE_PATH}/zapier/test`, request)
    return response.data
  }

  static async disconnectZapierIntegration(): Promise<void> {
    await apiClient.delete(`${this.BASE_PATH}/zapier`)
  }
}
